import React from "react";
import { Badge, Tooltip } from "@chakra-ui/react";
import { translateType } from "../../src/shared/libs/translate";
import { TooltipState } from "../helpers/Tooltip";

export default function CustomerVerified({ state }) {
  const color = {
    'true': "green",
    'false': "red",
  }[state];

  return (
    <Tooltip
      label={TooltipState(state)}
      bg="gray.100"
      color="black"
      placement="bottom"
    >
      <Badge variant="subtle" rounded={6} px="1" py="1" colorScheme={color}>
        {translateType(state)}
      </Badge>
    </Tooltip>
  );
}
